<template>
  <div id="top" class="mainWrapper">
    <!--nav-->
    <head-nav v-bind:gray="gray" v-bind:pos="'fixed'"></head-nav>
    <!--container-->
    <div class="innerWrapper">
      <h1>Edit account details</h1>
      <div class="container">
        <div class="dtls">
          <div class="inputItem">
            <div class="title">Company name</div>
            <input
              v-model="user.companyName"
              :class="{ red: companyNameWarn }"
              maxlength="50"
              type="text"
              @input="handleInput($event)"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">First name</div>
            <input
              v-model="user.firstName"
              :class="{ red: firstNameWarn }"
              maxlength="20"
              type="text"
              @input="handleInput($event)"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Surname</div>
            <input
              v-model="user.lastName"
              :class="{ red: lastNameWarn }"
              maxlength="20"
              type="text"
              @input="handleInput($event)"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Address</div>
            <input
              v-model="user.address"
              :class="{ red: addressWarn }"
              maxlength="50"
              type="text"
              @input="handleInput($event)"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Suburb</div>
            <input
              v-model="user.suburb"
              :class="{ red: suburbWarn }"
              maxlength="50"
              type="text"
              @input="handleInput($event)"
              @blur.capture="isFilled"
            />
          </div>
          <div class="doubleSelectItem clear">
            <div class="selectItem">
              <div class="title">State</div>
              <div :class="{ open: open }" class="select">
                <!--<el-select v-model="user.state" placeholder="select" @visible-change="visibleState">
                    <el-option
                    v-for="item in optionsPos"
                    :key="item.key"
                    :label="item.value"
                    :value="item.value">
                    </el-option>
                </el-select>-->
                <div class="mol" @click.stop="openState">{{ user.state }}</div>
                <transition name="fade">
                  <ul v-if="open" style="height:6.3rem">
                    <li
                      v-for="item in optionsPos"
                      :key="item.key"
                      :class="{ selected: item.value == user.state }"
                      @click.stop="posChange(item.value)"
                    >
                      {{ item.value }}
                    </li>
                  </ul>
                </transition>
              </div>
            </div>
          </div>
          <div class="inputItem">
            <div class="title">Postcode</div>
            <input
              v-model="user.postcode"
              :class="{ red: postcodeWarn }"
              maxlength="4"
              type="number"
              @input="handleInput($event, 'code')"
              @blur.capture="isFilled"
            />
          </div>

          <div class="inputItem">
            <div class="title">Phone number:</div>
            <input
              v-model="user.phoneNumber"
              maxlength="20"
              type="text"
              @input="handleInput($event, 'phone')"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Mobile</div>
            <input
              v-model="user.mobileNumber"
              :class="{ red: mobileNumberWarn }"
              maxlength="20"
              type="text"
              @input="handleInput($event, 'mobile')"
              @blur.capture="isFilled"
            />
          </div>
          <div class="inputItem">
            <div class="title">Email</div>
            <div class="input">{{ user.email }}</div>
          </div>
          <div class="inputItem">
            <div class="title">C/C email</div>
            <input
              v-model="user.ccEmail"
              :class="{ red: cemailWarn }"
              type="text"
              @change="validateEmail($event, 'cemail')"
              @input="handleInput($event)"
              @blur.capture="isFilled('ccEmail')"
            />
            <!--<i class="close" v-if="cemailWarn" @click="clean('cemail')"></i>
            <strong v-if="cemailWarn">Email format is incorrect. Please try again.</strong>-->
          </div>
          <div class="inputItem">
            <div class="title">ABN or ACN</div>
            <input
              v-model="user.abn"
              :class="{ red: abnWarn }"
              maxlength="11"
              type="number"
              @input="handleInput($even, 'abn')"
              @blur.capture="isFilled"
            />
          </div>
          <button @click="editInfo">Save changes</button>
        </div>
      </div>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      gray: true,
      open: false,
      disable: true,
      optionsPos: [
        {
          value: "New South Wales",
          key: 0
        },
        {
          value: "Queensland",
          key: 1
        },
        {
          value: "South Australia",
          key: 2
        },
        {
          value: "Tasmania",
          key: 3
        },
        {
          value: "Victoria",
          key: 4
        },
        {
          value: "Western Australia",
          key: 5
        },
        {
          value: "Northern Territory",
          key: 6
        },
        {
          value: "ACT",
          key: 7
        },
        {
          value: "ALL",
          key: 8
        }
      ],
      user: {
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        address: "",
        suburb: "",
        state: "",
        postcode: "",
        abn: "",
        mobileNumber: "",
        phoneNumber: "",
        ccEmail: ""
      },
      companyNameWarn: false,
      firstNameWarn: false,
      lastNameWarn: false,
      addressWarn: false,
      suburbWarn: false,
      postcodeWarn: false,
      phoneNumberWarn: false,
      mobileNumberWarn: false,
      cemailWarn: false,
      abnWarn: false
    };
  },
  created() {
    var that = this;
    that.getUserDtl({ callback: that.callback });
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    ...mapActions("account", ["getUserDtl", "submitUserInfo"]),
    visibleState(e) {
      this.open = e;
      this.$forceUpdate();
    },
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.user = res.data.data;
        that.user.phoneNumber = that.user.phoneNumber.replace(/\s+/g, "");
        // that.user.phoneNumber = that.$box.formatTelEight(that.user.phoneNumber)
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    editInfo() {
      var that = this;
      if (
        that.user.companyName.replace(/\s+/g, "") == "" ||
        that.user.firstName.replace(/\s+/g, "") == "" ||
        that.user.lastName.replace(/\s+/g, "") == "" ||
        that.user.address.replace(/\s+/g, "") == "" ||
        that.user.suburb.replace(/\s+/g, "") == "" ||
        that.user.postcode.replace(/\s+/g, "") == "" ||
        /*that.user.phoneNumber.replace(/\s+/g,"") == '' ||*/
        that.user.mobileNumber.replace(/\s+/g, "") == "" ||
        /* that.user.ccEmail.replace(/\s+/g,"") == '' || */
        that.user.abn.replace(/\s+/g, "") == ""
      ) {
        if (that.user.companyName.replace(/\s+/g, "") == "") {
          that.companyNameWarn = true;
        }
        if (that.user.firstName.replace(/\s+/g, "") == "") {
          that.firstNameWarn = true;
        }
        if (that.user.lastName.replace(/\s+/g, "") == "") {
          that.lastNameWarn = true;
        }
        if (that.user.address.replace(/\s+/g, "") == "") {
          that.addressWarn = true;
        }
        if (that.user.suburb.replace(/\s+/g, "") == "") {
          that.suburbWarn = true;
        }
        if (that.user.postcode.replace(/\s+/g, "") == "") {
          that.postcodeWarn = true;
        }
        /* if (that.user.phoneNumber.replace(/\s+/g,"") == '') {
            that.phoneNumberWarn = true
        } */
        if (that.user.mobileNumber.replace(/\s+/g, "") == "") {
          that.mobileNumberWarn = true;
        }
        /* if (that.user.ccEmail.replace(/\s+/g,"") == '') {
            that.cemailWarn = true
        } */
        if (that.user.abn.replace(/\s+/g, "") == "") {
          that.abnWarn = true;
        }
        return false;
      }
      that.user.phoneNumber = that.user.phoneNumber.replace(/\s+/g, "");
      delete that.user.email;
      /* if (that.cemailWarn) {
          delete that.user.ccEmail
      } */
      that.submitUserInfo({ params: that.user, callback: that.editCallback });
    },
    editCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        if (!that.$route.params.id) {
          that.$router.push("/account");
        } else {
          that.$router.push({
            path: `/property/write/${that.$route.params.id}/${that.$route.params.roomId}`,
            query: { from: 0 }
          });
        }
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    // 校验邮编 + 电话
    handleInput(e, type) {
      var that = this;
      /*if (type == 'mobile') {
          that.user.mobileNumber = that.user.mobileNumber.replace(/[^\d]/g,'')
          if (that.user.mobileNumber.length > 15) {
              that.user.mobileNumber = that.user.mobileNumber.slice(0, 15)
          }
      }
      else if (type == 'phone'){
          that.user.phoneNumber = that.user.phoneNumber.replace(/[^\d]/g,'')
          if (that.user.phoneNumber.length > 15) {
              that.user.phoneNumber = that.user.phoneNumber.slice(0, 15)
          }
      }*/
      if (type == "code") {
        that.user.postcode = that.user.postcode.replace(/[^\d]/g, "");
        if (that.user.postcode.length > 4) {
          that.user.postcode = that.user.postcode.slice(0, 4);
        }
      }

      // 正在输入去掉红框
      if (that.user.companyName.replace(/\s+/g, "") !== "") {
        that.companyNameWarn = false;
      }
      if (that.user.firstName.replace(/\s+/g, "") !== "") {
        that.firstNameWarn = false;
      }
      if (that.user.lastName.replace(/\s+/g, "") !== "") {
        that.lastNameWarn = false;
      }
      if (that.user.address.replace(/\s+/g, "") !== "") {
        that.addressWarn = false;
      }
      if (that.user.suburb.replace(/\s+/g, "") !== "") {
        that.suburbWarn = false;
      }
      if (that.user.postcode.replace(/\s+/g, "") !== "") {
        that.postcodeWarn = false;
      }
      /*if (that.user.phoneNumber.replace(/\s+/g,"") !== '') {
          that.phoneNumberWarn = false
      }*/
      if (that.user.mobileNumber.replace(/\s+/g, "") !== "") {
        that.mobileNumberWarn = false;
      }
      /* if (that.user.ccEmail.replace(/\s+/g,"") !== '') {
          that.cemailWarn = false
      } */
      if (that.user.abn.replace(/\s+/g, "") !== "") {
        that.abnWarn = false;
      }
      that.$forceUpdate();
    },
    // 校验邮箱
    validateEmail(e, type) {
      var that = this;
      var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (type == "email") {
        if (that.user.email == "") {
          that.emailwarn = false;
          return;
        }
        if (reg.test(that.user.email)) {
          that.emailwarn = false;
        } else {
          that.emailwarn = true;
        }
        that.$forceUpdate();
      } /* else if (type == 'cemail') {
                if(that.user.ccEmail == '') {
                    that.cemailWarn = false
                    return
                }
                if(reg.test(that.user.ccEmail)) {
                    that.cemailWarn = false
                } else{
                    that.cemailWarn = true
                }
                that.$forceUpdate()
            } */
    },
    // 清除邮箱
    clean(type) {
      var that = this;
      if (type == "email") {
        that.emailwarn = false;
        that.user.email = "";
        this.$forceUpdate();
      } /* else if (type == 'cemail') {
                that.cemailWarn = false
                that.user.ccEmail = ''
                this.$forceUpdate()
            } */
    },
    // 判断是否输入完整
    isFilled() {
      var that = this;
      if (
        that.user.firstName.replace(/\s+/g, "").length > 0 &&
        that.user.lastName.replace(/\s+/g, "").length > 0 &&
        that.user.email.replace(/\s+/g, "").length > 0 &&
        that.user.companyName.replace(/\s+/g, "").length > 0 &&
        that.user.address.replace(/\s+/g, "").length > 0 &&
        that.user.suburb.replace(/\s+/g, "").length > 0 &&
        that.user.state.replace(/\s+/g, "").length > 0 &&
        that.user.postcode.replace(/\s+/g, "").length > 0 &&
        that.user.abn.replace(/\s+/g, "").length > 0 &&
        that.user.mobileNumber.replace(/\s+/g, "").length >
          0 /*&&
            that.user.phoneNumber.replace(/\s+/g,"").length > 0 &&
            that.user.ccEmail.replace(/\s+/g,"").length > 0 */
      ) {
        that.disable = false;
      } else {
        that.disable = true;
      }
    }
  },
  components: {
    headNav,
    footNav
  }
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  width: 100%;
  position: relative;
}

.innerWrapper {
  width: 100%;
  margin: 0 auto;
  padding: 0 0.32rem;
  padding-top: 1.52rem;
  box-sizing: border-box;

  h1 {
    font-size: 0.56rem;
    color: #2a2929;
    line-height: 0.68rem;
    margin-bottom: 0.8rem;
    font-family: ProximaNova-Semibold;
  }

  .container {
    width: 100%;
    margin: 0 auto;

    .dtls {
      width: 100%;
      box-sizing: border-box;
      margin-bottom: 0.48rem;
    }

    .inputItem {
      margin-bottom: 0.36rem;
      position: relative;

      .title {
        color: #8f8f8f;
        font-size: 0.28rem;
        line-height: 0.34rem;
        margin-bottom: 0.24rem;
      }

      input {
        border: 1px solid #e2e0e3;
        border-radius: 6px;
        box-sizing: border-box;
        width: 100%;
        height: 0.92rem;
        position: relative;
        line-height: 0.92rem;
        padding-left: 0.2rem;
        font-size: 0.3rem;
        color: #333333;
        outline: none;
        transition: border 0.5s;
      }

      .input {
        border: 1px solid #e2e0e3;
        border-radius: 6px;
        box-sizing: border-box;
        width: 100%;
        height: 0.92rem;
        position: relative;
        line-height: 0.92rem;
        padding-left: 0.2rem;
        font-size: 0.3rem;
        color: #333333;
        outline: none;
        transition: border 0.5s;
        background: #ddd;
        cursor: not-allowed;
      }

      .red {
        border: 1px solid #ff4e4e;
      }

      .close {
        display: block;
        width: 0.32rem;
        height: 0.32rem;
        position: absolute;
        right: 0.32rem;
        top: 0.84rem;
        background-repeat: no-repeat;
        background-size: 0.32rem 0.32rem;
        background-position: center center;
        background-image: url("../../assets/null.png");
        cursor: pointer;
      }

      strong {
        font-weight: normal;
        position: absolute;
        left: 0;
        top: 1.55rem;
        font-size: 0.28rem;
        color: #ff4e4e;
        width: 110%;
      }
    }

    .selectItem {
      margin-bottom: 0.36rem;

      .title {
        color: #8f8f8f;
        font-size: 0.28rem;
        line-height: 0.34rem;
        margin-bottom: 0.24rem;
      }

      .select {
        border: 1px solid #e2e0e3;
        border-radius: 0.12rem;
        box-sizing: border-box;
        width: 100%;
        height: 0.92rem;
        position: relative;

        .mol {
          line-height: 0.92rem;
          width: 100%;
          box-sizing: border-box;
          font-size: 0.3rem;
          color: #3f3f46;
          padding-left: 0.2rem;
          height: 0.92rem;
        }

        ul {
          position: absolute;
          width: 80%;
          left: 0;
          top: 1rem;
          z-index: 2;
          border: 1px solid #e4e7ed;
          border-radius: 4px;
          background-color: #fff;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          box-sizing: border-box;

          li {
            font-size: 0.28rem;
            padding: 0 20px;
            position: relative;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #606266;
            height: 0.7rem;
            line-height: 0.7rem;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            cursor: pointer;
          }

          .selected {
            color: #409eff;
            font-weight: 700;
          }
        }
      }

      .select:before {
        content: "";
        display: block;
        position: absolute;
        right: 0.4rem;
        top: 0.4rem;
        width: 0.26rem;
        height: 0.14rem;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        background-image: url("../../assets/arrw.png");
        transition: all 0.5s;
      }

      .open:before {
        transform: rotate(180deg);
      }
    }

    .doubleSelectItem {
      .selectItem,
      .inputItem {
        float: left;
        margin-right: 0.22rem;
        width: 100%;
      }

      .inputItem {
        margin: 0;
      }
    }

    button {
      border: none;
      display: block;
      margin: 0.64rem auto 0.96rem auto;
      width: 5.18rem;
      height: 0.92rem;
      border-radius: 0.12rem;
      box-sizing: border-box;
      font-size: 0.3rem;
      background: #2cca73;
      color: #fff;
      cursor: pointer;
    }

    .disabled {
      background: #a1e4be;
      border: 1px solid #a1e4be;
    }
  }
}

.select .el-input__inner {
  height: 0.92rem;
  line-height: 0.92rem;
  border: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/account/edit.vue